import DepositViews from '@deposits/views'
import AccountViews from '@account/views'
import LoanViews from '@loan/views'
import CreditCardViews from '@credit-card/views'

export const depositViews = DepositViews
export const accountViews = AccountViews
export const loanViews = LoanViews
export const creditCardViews = CreditCardViews
